"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnbrandedEducationTheme = exports.createUnbrandedTheme = void 0;
const ModernaTheme_1 = require("./ModernaTheme");
const createUnbrandedTheme = ({ accent }) => {
    return Object.assign(Object.assign({}, ModernaTheme_1.ModernaTheme), { colorsDark: {
            accent01: accent,
            accent02: "#A652B8",
            accent03: "#B977C9",
            accent04: "#CD9CDA",
            background01: "#242C2C",
            background02: "#FFF",
            background03: "#515858",
            backgroundNeutral01: "#2E3535",
            backgroundNeutral02: "#4A5151",
            backgroundNeutral03: "#99A4A4",
            backgroundNeutral04: "#7F8989",
            backgroundNeutral05: "#99A4A4",
            backgroundOverlay01: "#242C2CCC",
            buttonActiveBackgroundColorPrimary: "#01283C",
            buttonActiveBackgroundColorSecondary: "transparent",
            buttonActiveBorderColorPrimary: "#FFFFFF",
            buttonActiveBorderColorSecondary: "#FFFFFF",
            buttonActiveColorPrimary: "#FFFFFF",
            buttonActiveColorSecondary: "#FFFFFF",
            buttonBackgroundColorDisabled: "#7A6F7C",
            buttonBackgroundColorPrimary: "#FFFFFF",
            buttonBackgroundColorSecondary: "transparent",
            buttonBorderColorPrimary: "#FFFFFF",
            buttonBorderColorSecondary: accent,
            buttonColorPrimary: "#000000",
            buttonColorSecondary: "#FFFFFF",
            buttonColorTertiary: "#FFFFFF",
            buttonFocusBorderColorPrimary: "#515858",
            buttonFocusBorderColorSecondary: "#FFFFFF",
            buttonFocusBorderColorTertiary: "#FFFFFF",
            buttonHoverBackgroundColorPrimary: "#01283C",
            buttonHoverBackgroundColorSecondary: "transparent",
            buttonHoverBorderColorPrimary: "#FFFFFF",
            buttonHoverBorderColorSecondary: "#bf99c7",
            buttonHoverColorPrimary: "#FFFFFF",
            buttonHoverColorSecondary: "#FFFFFF",
            cta01: accent,
            cta01Text: "#FFFFFF",
            cta01TextHover: "#E8DAF3",
            cta02: "#FFFFFF",
            cta02Text: "#000000",
            cta02TextHover: "#D8D8D8",
            disabled01: "#7A6F7C",
            dropdownActive: accent,
            dropdownHover: "#F9F2F9",
            error01: "#F2AFC4",
            error02: "#E78CA3",
            error03: "#DB6B82",
            gradientTop: "linear-gradient(to bottom, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0.3) 90%, rgba(255, 255, 255, 0) 100%)",
            gradientBottom: "linear-gradient(to top, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0.3) 90%, rgba(255, 255, 255, 0) 100%)",
            headline01: "#FFFFFF",
            headline02: "#E8DAF3",
            headlineLevel1: "#FFFFFF",
            iconButtonActiveBackgroundColor: accent,
            iconButtonBackgroundColor: "#FFFFFF",
            iconButtonColorPrimary: "#000000",
            iconButtonColorSecondary: "#FFFFFF",
            iconButtonFocusBorderColor: "#515858",
            iconButtonHoverBackgroundColor: "#bf99c7",
            iconButtonHoverBorderColor: accent,
            iconButtonOutlineBackgroundColor: "transparent",
            iconButtonOutlineColor: "#FFFFFF",
            inputBackgroundColor: "#FFFFFF",
            inputLabel: "#191F2A",
            link01: "#D8D8D8",
            link02: "#A676B2",
            notification01: accent,
            notification02: "#A652B8",
            notification03: "#B977C9",
            stroke01: "#FFFFFF",
            stroke02: "#7A6F7C",
            stroke03: accent,
            success01: "#A3D1AF",
            success02: "#89BA96",
            success03: "#6F9C7C",
            tableBodyEvenBackgroundColor: "#FFFFFF",
            tableBodyOddBackgroundColor: "#F9F9FA",
            tableHeaderBackgroundColor: "#005E83",
            tableFooterBackgroundColor: "#D8D8D8",
            text01: "#FFFFFF",
            text02: "#E8E8E8",
            text03: "#CBB8D3",
            text04: "#FFFFFF",
            warning01: "#F8D7A9",
            warning02: "#F2BC91",
            warning03: "#ECA06D"
        }, colorsLight: {
            accent01: accent,
            accent02: "#BF99C7",
            accent03: "#D4B2D9",
            accent04: "#E9CCEB",
            background01: "#FFFFFF",
            background02: "#F9F2F9",
            background03: "#F4E5F4",
            backgroundNeutral01: "#F9F9FA",
            backgroundNeutral02: "#EAEBEF",
            backgroundNeutral03: "#DCDEE3",
            backgroundNeutral04: "#9499A8",
            backgroundNeutral05: "#697084",
            backgroundOverlay01: "#F9F9FACC",
            buttonActiveBackgroundColorPrimary: "#01283C",
            buttonActiveBackgroundColorSecondary: "transparent",
            buttonActiveBorderColorPrimary: "#FFFFFF",
            buttonActiveBorderColorSecondary: accent,
            buttonActiveColorPrimary: "#FFFFFF",
            buttonActiveColorSecondary: "#01283C",
            buttonBackgroundColorDisabled: "#7A6F7C",
            buttonBackgroundColorPrimary: accent,
            buttonBackgroundColorSecondary: "transparent",
            buttonBorderColorPrimary: "#FFFFFF",
            buttonBorderColorSecondary: "#01283C",
            buttonColorPrimary: "#FFFFFF",
            buttonColorSecondary: "#01283C",
            buttonColorTertiary: "#01283C",
            buttonFocusBorderColorPrimary: "#7A1D8E",
            buttonFocusBorderColorSecondary: accent,
            buttonFocusBorderColorTertiary: "#01283C",
            buttonHoverBackgroundColorPrimary: "#01283C",
            buttonHoverBackgroundColorSecondary: "transparent",
            buttonHoverBorderColorPrimary: "#FFFFFF",
            buttonHoverBorderColorSecondary: accent,
            buttonHoverColorPrimary: "#FFFFFF",
            buttonHoverColorSecondary: "#01283C",
            cta01: accent,
            cta01Text: "#FFFFFF",
            cta01TextHover: "#FFFFFF",
            cta02: "#FFFFFF",
            cta02Text: "#000000",
            cta02TextHover: accent,
            disabled01: "#E8E2E8",
            dropdownActive: accent,
            dropdownHover: "#F9F2F9",
            error01: "#E22929",
            error02: "#F58A8A",
            error03: "#FFF3F3",
            gradientTop: "linear-gradient(to bottom, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0.3) 90%, rgba(255, 255, 255, 0) 100%)",
            gradientBottom: "linear-gradient(to top, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0.3) 90%, rgba(255, 255, 255, 0) 100%)",
            headline01: "#3A3A3A",
            headline02: "#5C5C5C",
            headlineLevel1: "#3A3A3A",
            iconButtonActiveBackgroundColor: accent,
            iconButtonBackgroundColor: "#E9CCEB",
            iconButtonColorPrimary: "#191F2A",
            iconButtonColorSecondary: "#191F2A",
            iconButtonFocusBorderColor: "#7A1D8E",
            iconButtonHoverBackgroundColor: "#bf99c7",
            iconButtonHoverBorderColor: accent,
            iconButtonOutlineBackgroundColor: "transparent",
            iconButtonOutlineColor: "#FFFFFF",
            inputBackgroundColor: "#FFFFFF",
            inputLabel: "#191F2A",
            link01: accent,
            link02: "#BF99C7",
            notification01: accent,
            notification02: "#BF99C7",
            notification03: "#D4B2D9",
            stroke01: "#5C5C5C",
            stroke02: "#E8E2E8",
            stroke03: accent,
            success01: "#048556",
            success02: "#6BCB9E",
            success03: "#EBF8F2",
            tableBodyEvenBackgroundColor: "#FFFFFF",
            tableBodyOddBackgroundColor: "#F9F9FA",
            tableHeaderBackgroundColor: "#005E83",
            tableFooterBackgroundColor: "#D8D8D8",
            text01: "#191F2A",
            text02: "#383D47",
            text03: "#083952",
            text04: "#FFFFFF",
            warning01: "#FDB022",
            warning02: "#FFD785",
            warning03: "#FFF9EC"
        }, radii: Object.assign(Object.assign({}, ModernaTheme_1.ModernaTheme.radii), { buttonBorderRadius: 100, iconButtonBorderRadiusCircle: 100, iconButtonBorderRadiusSquare: 8, inputBorderRadius: 100 }), fontSizes: [12, 14, 16, 18, 20, 24, 24, 24, 24, 30, 40, 48, 60], shadows: Object.assign(Object.assign({}, ModernaTheme_1.ModernaTheme.shadows), { boxShadow01: "0px 8px 28px 0px rgba(0, 0, 0, 0.2), 0px 2px 24px 0px rgba(0, 0, 0, 0.1)" }) });
};
exports.createUnbrandedTheme = createUnbrandedTheme;
exports.UnbrandedEducationTheme = (0, exports.createUnbrandedTheme)({
    accent: "#9121A6"
});
//# sourceMappingURL=UnbrandedEducationTheme.js.map